const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;

//@Actions
const actionTypes = require('constants/actionTypes');

//@ constants
const {
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM,
    BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,
} = require('constants/index');

const getFiltersRequest = () => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_REQUEST,
    };
};

const getFiltersSuccess = response => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_SUCCESS,
        payload: {
            data: response,
        },
    };
};

const getFiltersFailure = response => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_FAILURE,
        payload: {
            data: response,
        },
    };
};

const getConfigurationFiltersSuccess = response => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_CONFIG_FILTERS_SUCCESS,
        payload: {
            data: response,
        },
    };
};

const getConfigurationFiltersFailure = response => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_CONFIG_FILTERS_FAILURE,
        payload: {
            data: response,
        },
    };
};

const getFilters = () => dispatch => {
    const requestData = {
        query: {
            assetsGrouped: true,
        },
    };

    dispatch(getFiltersRequest());

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('catalogueBrokerSimpleSearchCombos'),
        requestData,
    ).then(
        response => {
            dispatch(getFiltersSuccess(response));
        },
        response => {
            dispatch(getFiltersFailure(response));
        },
    );
};

const applyLimitedFilters = (filterType, limitedFilters) => ({
    type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_LIMITED,
    payload: {
        filterType,
        limitedFilters,
    },
});

const retryCombosFilters = () => dispatch => {
    dispatch(getFilters());
};

const updateFiltersCombosConfiguration = () => (dispatch, getState) => {
    const combos = getState().brokerProductFiltersSearch.get('combos');

    let combosAdapter = {};
    combos.map((item, key) => {
        combosAdapter[`combos[${key}].name`] = item.name;
        combosAdapter[`combos[${key}].value`] = item.value;
    });

    dispatch(getFiltersRequest());

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('catalogueBrokerSimpleSearchCombosConfiguration'),
        { query: combosAdapter },
    ).then(
        response => {
            dispatch(getConfigurationFiltersSuccess(response));
        },
        response => {
            dispatch(getConfigurationFiltersFailure(response));
        },
    );
};

const clearFilters = () => dispatch => {
    dispatch({ type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_CLEAR });
};

const clearResults = () => dispatch => {
    dispatch({ type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_CLEAR });
    dispatch({ type: actionTypes.BROKER_ADVANCED_SEARCH_RESULTS_CLEAR });
};

const handleFieldChange = (field, value) => dispatch => {
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_FILTER_CHANGE,
        payload: {
            field,
            value,
        },
    });
    if (field !== BROKER_PRODUCT_ADVANCED_SEARCH_TERM) {
        dispatch(updateFiltersCombosConfiguration());
    }
};

const handleFieldMultipleChange = (field, value) => dispatch => {
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_MULTIPLE_PRODUCT_FILTER_CHANGE,
        payload: {
            field,
            value,
        },
    });
    dispatch(updateFiltersCombosConfiguration());
};

const handleFieldMultipleAssetChange = (field, value) => dispatch => {
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_MULTIPLE_ASSET_FILTER_CHANGE,
        payload: {
            field,
            value,
        },
    });
    dispatch(updateFiltersCombosConfiguration());
};

const resetSpecificProduct = product => dispatch => {
    dispatch({ type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_CLEAR });
    dispatch({ type: actionTypes.BROKER_ADVANCED_SEARCH_RESULTS_CLEAR });
    dispatch(
        handleFieldMultipleChange(
            BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES,
            [
                {
                    value: product,
                    label: formatText(
                        `brokerAdvancedSearch-brokerAdvancedSearch_${product}`,
                    ),
                },
            ],
        ),
    );
};

module.exports = {
    applyLimitedFilters,
    getFilters,
    handleFieldChange,
    handleFieldMultipleChange,
    handleFieldMultipleAssetChange,
    clearFilters,
    clearResults,
    updateFiltersCombosConfiguration,
    retryCombosFilters,
    resetSpecificProduct,
};
